import React, { useEffect, useRef } from "react";

declare global {
    interface Window {
        Trustpilot?: {
            loadFromElement: (element: Element, options?: unknown, callback?: unknown) => void;
        };
    }
}

type TrustPilotCarouselProps = {
    locale?: string;
    businessUnitId?: string;
    reviewLink?: string;
    theme?: "light" | "dark";
    height?: string;
};

const TRUSTPILOT_SCRIPT_ID = "trustpilot-widget-bootstrap";
const TRUSTPILOT_SCRIPT_SRC = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";

export function TrustPilotCarousel({
    locale = "en-US",
    businessUnitId = "5ced60ecfeac9d0001b63194",
    reviewLink = "https://www.trustpilot.com/review/aaalife.com",
    theme = "light",
    height = "260px",
}: TrustPilotCarouselProps) {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        function renderWidget() {
            if (window.Trustpilot && containerRef.current) {
                window.Trustpilot.loadFromElement(containerRef.current);
            }
        }

        const existing = document.getElementById(TRUSTPILOT_SCRIPT_ID) as HTMLScriptElement | null;
        if (existing) {
            renderWidget();
            return;
        }

        const script = document.createElement("script");
        script.id = TRUSTPILOT_SCRIPT_ID;
        script.src = TRUSTPILOT_SCRIPT_SRC;
        script.async = true;
        script.onload = renderWidget;
        document.body.appendChild(script);
    }, []);

    return (
        <div className="w-full flex justify-center pt-10">
            <div
                ref={containerRef}
                className="trustpilot-widget w-full max-w-content"
                data-locale={locale}
                data-template-id="54ad5defc6454f065c28af8b"
                data-businessunit-id={businessUnitId}
                data-style-height={height}
                data-style-width="100%"
                data-theme={theme}
                data-stars="5"
            >
                <a href={reviewLink} target="_blank" rel="noopener noreferrer">
                    Trustpilot
                </a>
            </div>
        </div>
    );
}

export default TrustPilotCarousel;
